import client from '../clients/client';

export type ActiveSubscription = {
  id: string;
  name: string;
  status: string;
  createdAt: string;
  trialDays: number;
};

export type ExtendTrialResult = {
  subscription: ActiveSubscription;
  // Set when Shopify extended the trial but the shop's billing record wasn't updated.
  billing_error: string | null;
};

export const extendTrial = async (shopId: string, days: number): Promise<ExtendTrialResult> => {
  const response = await client.post<ExtendTrialResult>(
    `/billings/active/${encodeURIComponent(shopId)}/extend-trial`, { days });
  return response.data;
};
